// import { useNavigate } from 'react-router-dom';
import './App.css';
import Routes from './routes';
// import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
// import { checkAuth } from './store/user/userActions';

function App() {
    // const navigate = useNavigate();
    // const dispatch = useDispatch();

    // useEffect(() => {
    //     // Dispatch the checkAuth action during application initialization
    //     dispatch(checkAuth(navigate));
    //   }, [dispatch, navigate]);
    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://embed.tawk.to/5eaae1b5203e206707f85913/default";
        script.async = true;
        script.charset = "UTF-8";
        script.setAttribute("crossorigin", "*");
    
        document.body.appendChild(script);
    
        return () => {
          document.body.removeChild(script);
        };
      }, []);
    return (
        <Routes />
    );
}

export default App;
